import React from 'react';

import { EmptyListImage, EmptySearchImage } from '@vk-hr-tek/ui/graphics';

const IMAGES = {
  search: EmptySearchImage,
  list: EmptyListImage,
} as const;

export type EmptyStateMode = keyof typeof IMAGES;

export const EmptyStateImage = ({
  mode = 'list',
}: {
  mode?: EmptyStateMode;
}) => {
  const Image = IMAGES[mode];
  return <Image />;
};
